import { render, staticRenderFns } from "./CamionesTable.vue?vue&type=template&id=16c673d3"
import script from "./CamionesTable.vue?vue&type=script&lang=js"
export * from "./CamionesTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports